import { PAYMENT_ACCOUNT_TYPE_PLACEHOLDER, type PaymentAccountType } from '@klear/payment/constants'

export type PayableAccountSide = 'source' | 'destination'

const ACCOUNT_TO_CHOOSE: Record<PayableAccountSide, string> = {
  source: 'a source account',
  destination: 'a destination bank account'
}

export function placeholderAccountSides(accounts: {
  sourceAccountType?: PaymentAccountType | null
  destinationAccountType?: PaymentAccountType | null
}): PayableAccountSide[] {
  const sides: PayableAccountSide[] = []
  if (accounts.sourceAccountType === PAYMENT_ACCOUNT_TYPE_PLACEHOLDER) sides.push('source')
  if (accounts.destinationAccountType === PAYMENT_ACCOUNT_TYPE_PLACEHOLDER) sides.push('destination')
  return sides
}

export function accountsToChoose(sides: PayableAccountSide[]): string {
  return sides.map((side) => ACCOUNT_TO_CHOOSE[side]).join(' and ')
}
